import { render, staticRenderFns } from "./NodeEditorContainer.vue?vue&type=template&id=5b37a464&scoped=true&lang=pug&"
import script from "./NodeEditorContainer.vue?vue&type=script&lang=ts&"
export * from "./NodeEditorContainer.vue?vue&type=script&lang=ts&"
import style0 from "./NodeEditorContainer.vue?vue&type=style&index=0&id=5b37a464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b37a464",
  null
  
)

export default component.exports